import React from 'react'

export default function TimelinePageLayout({
  header,
  sidebar,
  calendar,
  children,
}) {
  return (
    <div className="flex h-full w-full flex-col overflow-hidden">
      <div className="shrink-0">
        {header}
      </div>
      <div className="flex min-h-0 flex-1 overflow-hidden">
        {sidebar}
        <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
          {calendar}
        </div>
      </div>
      {children}
    </div>
  )
}
